export default {"src":"/_next/static/media/employee-man.4bea4141.svg","height":17,"width":16};